/* eslint-disable no-shadow */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { HorizontalLogo } from '../branding/HorizontalLogo';
import { Title } from '../components/Title';
import { Button } from '../components/Button';
import { useEffect } from 'react';

const Styles = styled.div`
   max-width: 725px;
   margin: 0 auto;
   padding: 0 1em 2em;
   h1 {
      font-size: min(calc(0.1 * var(--safe-width)), 4em);

      font-family: var(--heading-font);

      margin-top: min(1.5em, calc(0.15 * (100vh - var(--safe-area-inset-y))));
      margin-bottom: min(0.5em, calc(0.1 * (100vh - var(--safe-area-inset-y))));
   }
   p {
      font-family: var(--content-font);

      font-size: min(calc(0.055 * var(--safe-width)), 1.3em);
   }
`;

const DailyComplete = () => {
   useEffect(() => {
      localStorage.setItem(
         'eiauth-lastDailyComplete',
         new Date().toISOString()
      );
   }, []);
   return (
      <div>
         <Title title="Daily Practice Complete!" />
         <Styles>
            <h1>Great Work!</h1>
            <p style={{ marginBottom: '1.5em', lineHeight: 1.4 }}>
               You have completed your daily practice.
            </p>
            <Button as={Link} to="/app/dashboard" className="button-cta">
               Go to Dashboard
            </Button>
         </Styles>
      </div>
   );
};

export { DailyComplete };
